import { apiClient } from "./client";

export const templatesApi = {
  list: async (params = {}) => (await apiClient.get("/careplans/templates/", { params })).data,
  get: async (id) => (await apiClient.get(`/careplans/templates/${id}/`)).data,
  create: async (data) => (await apiClient.post("/careplans/templates/", data)).data,
  update: async (id, data) => (await apiClient.patch(`/careplans/templates/${id}/`, data)).data,
  delete: async (id) => {
    await apiClient.delete(`/careplans/templates/${id}/`);
  },
};

export const carePlansApi = {
  list: async (params = {}) => (await apiClient.get("/careplans/plans/", { params })).data,
  get: async (id) => (await apiClient.get(`/careplans/plans/${id}/`)).data,
  create: async (data) => (await apiClient.post("/careplans/plans/", data)).data,
  update: async (id, data) => (await apiClient.patch(`/careplans/plans/${id}/`, data)).data,
  delete: async (id) => {
    await apiClient.delete(`/careplans/plans/${id}/`);
  },
};
